import React, { useState } from 'react';
import { Switch } from 'antd';

import './filter-benchmark-segment.less';
import { FormattedMessage } from 'react-intl';
import globalMessages from 'translations/messages';

const BenchmarkSegment = ({
  segment,
  onToggle,
}) => {
  const [toggling, setToggling] = useState(false);
  const toggleSegment = async (isEnabled) => {
    setToggling(true);
    await onToggle(segment.id, isEnabled);
    setToggling(false);
  };

  return (
    <div className={`filter-benchmark-segment ${segment.isConnected ? 'filter-benchmark-segment__connected' : ''}`}>
      <div className="filter-benchmark-segment__header">
        <span className="filter-benchmark-segment__title">
          {segment.isEnabled && (
          <span
            style={{
              display: 'inline-block',
              borderRadius: 2,
              height: 10,
              width: 10,
              marginRight: '.5em',
              backgroundColor: segment.color,
            }}
          />
          )}
          {segment.isGlobal ? <FormattedMessage {...globalMessages.globalBenchmark} /> : segment?.surveyCategory?.title}
        </span>
        <Switch
          size="small"
          checked={segment.isEnabled}
          loading={toggling}
          onChange={toggleSegment}
        />
      </div>
    </div>
  );
};

export default BenchmarkSegment;
